import { useSyncExternalStore } from 'react'
import { getLocale, setLocale, subscribeLocale } from './locale-store'
import { getDict } from './index'
import type { MktDict } from './dictionaries/en'
import type { LocaleCode } from './locales'

export interface UseLocale {
  locale: LocaleCode
  setLocale: (next: LocaleCode) => void
  dict: MktDict
}

/**
 * Subscribe to the active marketing locale. Re-renders the caller when the
 * locale changes (e.g. via the nav language switcher). `dict` is the resolved,
 * fully-typed copy for the current language.
 */
export function useLocale(): UseLocale {
  const locale = useSyncExternalStore(subscribeLocale, getLocale, getLocale)
  return { locale, setLocale, dict: getDict(locale) }
}
